import { Trans } from "../utils/i18n";
import Cookies from "js-cookie";
import React from "react";
import { hasProducts } from "./orderEntryEnfore";
import {validateEmailRegEx, validatePhoneNumber} from "../Shared/FormField";
import {addressConfig, addressConfigWithInvoice, addressInvoiceConfig} from "./components/address";
import {addressConfigB2b} from "./components/address_b2b";

export const orderEntryConfig = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "enableStepper": false,
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "groups": [
        {
            "description": <Trans i18nKey={"orderEntry.description"}>Your device is not behaving as you expect? <a href={"https://b2x.com/"} title={'B2X'} target={'_blank'}>B2X</a> support you from here to provide a solution quickly. Please complete the form below and we will get back to you to resolve the situation.</Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "requesttypeselect"
                }
            ]
        },
        {
            "id": "product_selection",
            "fields": [
                {
                    "size": "full",
                    "name": "productselectdynamic1",
                    "component": "productselectdynamic",
                    "mode": "serialnumber",
                    "conditionFunction": (values, orderEntryState) => !!values.requesttype && values.requesttype == 'service',

                },
                {
                    "size": "full",
                    "name": "productselectdynamic2",
                    "component": "productselectdynamic",
                    "conditionFunction": (values, orderEntryState) => !!values.requesttype && values.requesttype == 'new',
                },
            ],
            "conditionFunction":  values => values.requesttype === 'new' || values.requesttype === 'accessory' || values.requesttype === 'receipt' || values.requesttype === 'service' || values.requesttype === 'installation'
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.productSelection">Product selection</Trans></h2>,
            "description": <Trans i18nKey="orderEntry.productSelection.description"></Trans>,
            "id": "product_selection",
            "fields": [
                {
                    "size": "full",
                    "component": "productselect",
                    "conditionFunction": values => values.requesttype === 'incident' || values.requesttype === 'maintenance' || values.requesttype === 'return' || values.requesttype === 'rma'
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <Trans i18nKey={'orderEntry.serialnumber.description'}>Please enter your serial number here:</Trans>,
                    "conditionFunction": (values, orderEntryState) => {
                        const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product))

                        return (values.requesttype === 'incident' || values.requesttype === 'maintenance' || values.requesttype === 'return' || values.requesttype === 'rma') && values.product && !!product.is_serialized;
                    }
                },
                {
                    "name": "serialnumber",
                    "label": <Trans i18nKey="orderEntry.serialnumber.label">Serial number</Trans>,
                    "size": "full",
                    "required": true,
                    "type": "text",
                    "conditionFunction": (values, orderEntryState) => {
                        const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product))

                        return (values.requesttype === 'incident' || values.requesttype === 'maintenance' || values.requesttype === 'return') && values.product && !!product.is_serialized;
                    }
                },
                {
                    "component": "serialnumber",
                    "size": "full",
                    "required": true,
                    "validateSerialNumber": value => /^.{15}$/.test(value) ? undefined : <Trans i18nKey="serialNumber.write15chars">You have to provide exactly 15 characters</Trans>,
                    "uppercase": true,
                    "conditionFunction": (values, orderEntryState) => {
                        const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product))

                        return (values.requesttype === 'rma') && values.product && !!product.is_serialized;
                    }
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <Trans i18nKey={'orderEntry.quantity.description'}>Please enter the quantity here:</Trans>,
                    "conditionFunction": (values, orderEntryState) => {
                        const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product))

                        return (values.requesttype === 'incident' || values.requesttype === 'maintenance' || values.requesttype === 'return' || values.requesttype === 'rma') && values.product && !product.is_serialized;
                    }
                },
                {
                    "name": "quantity",
                    "label": <Trans i18nKey="orderEntry.quantity.label">Quantity</Trans>,
                    "size": "full",
                    "required": true,
                    "type": "number",
                    "conditionFunction": (values, orderEntryState) => {
                        const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product))

                        return (values.requesttype === 'incident' || values.requesttype === 'maintenance' || values.requesttype === 'return' || values.requesttype === 'rma') && values.product && !product.is_serialized;
                    }
                },
                {
                    "size": "full",
                    "component": "productselectmanual",
                    "conditionFunction": (values, orderEntryState) => {
                        return orderEntryState?.manualDeviceSelection;
                    },
                },
            ],
            "conditionFunction": values => values.requesttype === 'incident' || values.requesttype === 'maintenance' || values.requesttype === 'return' || values.requesttype === 'rma'
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.problemDescription">Problem description</Trans></h2>,
            "description": <Trans i18nKey="orderEntry.problemDescription.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "id": "problem_description",
            "fields": [
                {
                    "size": "full",
                    "component": "problemselectbig",
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product))

                return ( (values.requesttype === 'incident' || values.requesttype === 'rma') && values.product && (values.serialnumber || !product.is_serialized) );
            }
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.upload-documents">Upload Documents</Trans></h2>,
            "description": <Trans i18nKey="orderEntry.upload-documents.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "dropzoneform"
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product))

                return ( (values.requesttype === 'new' || values.requesttype === 'installation') && hasProducts(values.products) ) /*|| ( values.requesttype === 'service' && hasProducts(values.products) )*/ || ( (values.requesttype === 'incident' || values.requesttype === 'rma' || values.requesttype === 'maintenance') && values.product && (values.serialnumber || !product.is_serialized) );
            }
        },
        {
            "heading": <Trans i18nKey="queueDetail.appointment.label">Appointment</Trans>,
            "fields": [
                {
                    "name": "appointment_date",
                    "label": <Trans i18nKey="queueDetail.appointment.label">Installation Date</Trans>,
                    "size": "full",
                    "type": "datepicker",
                },
            ],
            "conditionFunction": (values) => {
                return (values.requesttype === 'new' || values.requesttype === 'installation') && hasProducts(values.products)
            }
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.addressContact">Contact information</Trans></h2>,
            "description": <Trans i18nKey="orderEntry.addressContact.description"></Trans>,
            "fields": [
                ...addressConfigB2b,
            ],
            "conditionFunction": (values, orderEntryState) => {
                const validProblem = values.problem_1 && values.problem_2;
                const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product))

                return ( values.requesttype === 'return' && (values.serialnumber || !product?.is_serialized) && values.product )
                        || ( (values.requesttype === 'receipt' || values.requesttype === 'installation') && hasProducts(values.products) && values.appointment_date )
                        || ( (values.requesttype === 'new') && hasProducts(values.products) )
                        || ( values.requesttype === 'accessory' && hasProducts(values.products) )
                        /*|| ( values.requesttype === 'service' && hasProducts(values.products) )*/
                        || ( values.requesttype === 'service' && values.products?.every(product => (values.requesttype == 'fastTrack' || product.serialnumber) && product.amount) )
                        || ( values.requesttype === 'maintenance' && (values.serialnumber || !product?.is_serialized) && values.product );
            }
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.addressContact">Contact information</Trans></h2>,
            "description": <Trans i18nKey="orderEntry.addressContact.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "id": "address",
            "fields": [
                ...addressConfigWithInvoice,
            ],
            "conditionFunction": (values, orderEntryState) => {
                const validProblem = values.problem_1 && values.problem_2;

                return ((values.requesttype === 'incident' && validProblem) || (values.requesttype === 'rma' && values.problem_1)) && values.product && values.serialnumber;
            },
        },
        {
            "heading": <h2><Trans i18nKey="orderEntry.customerReference.label">Customer references</Trans></h2>,
            "fields": [
                {
                    "name": "customer_reference",
                    "label": <Trans i18nKey="orderEntry.customerReference.label">Customer reference</Trans>,
                    "size": "full",
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                const validProblem = values.problem_1 && values.problem_2;
                const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product));
                const validName = values?.name || values?.first_name &&  values?.last_name;
                const validAddress = validName && values.city && values.street && values.zip && values.country_id && validatePhoneNumber.test(values.phone) && validateEmailRegEx.test(values.email);

                return ( ((values.requesttype === 'incident' && validProblem) || values.requesttype === 'maintenance') && values.product && values.serialnumber )
                        || ( values.requesttype === 'return' && (values.serialnumber || !product?.is_serialized) && values.product)
                        || ( (values.requesttype === 'receipt' || values.requesttype === 'installation') && hasProducts(values.products) && values.appointment_date )
                        || ( (values.requesttype === 'new') && hasProducts(values.products) )
                        || ( values.requesttype === 'accessory' && hasProducts(values.products) )
                        || ( values.requesttype === 'service' && hasProducts(values.products) )
                        && !!validAddress;
            }
        },
        {
            "heading": <Trans i18nKey="common.terms">Terms & Conditions</Trans>,
            "description": <Trans i18nKey="orderEntry.termsandconditions.description"></Trans>,
            "id": "terms",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.verifyAccountToPay'}>Verify your account to pay</Trans></h2>
                    </>,
                },
                {
                    "size": "full",
                    "component": "verify_phone_number"
                },
                {
                    "name": "terms_of_service",
                    "label": <Trans i18nKey="orderEntry.termsandconditions.label">I have read and accept the <a href={route('termsandconditions')} target={'_blank'}>Terms & Conditions</a> and the <a href={route('privacy')} target={'_blank'}>Privacy Statement</a></Trans>,
                    "size": "full",
                    "type": "checkbox",
                    "required": true
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                const validProblem = values.problem_1 && values.problem_2;
                const validName = values?.name || values?.first_name &&  values?.last_name;
                const validAddress = validName && values.city && values.street && values.zip && values.country_id && validatePhoneNumber.test(values.phone) && validateEmailRegEx.test(values.email);

                return (values.requesttype === 'rma' && values.problem_1) && values.product && values.serialnumber && validAddress;
            },
        }
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="orderEntry.send">Send</Trans>,
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": (values, orderEntryState) => {
                        const validProblem = values.problem_1 && values.problem_2;
                        const product = orderEntryState.products?.find((item) => item.id === parseInt(values.product))
                        const validName = values?.name || values?.first_name &&  values?.last_name;
                        const validAddress = validName && values.city && values.street && values.zip && values.country_id && validatePhoneNumber.test(values.phone) && validateEmailRegEx.test(values.email);

                        return ( ((values.requesttype === 'incident' && validProblem) || values.requesttype === 'maintenance') && values.product && values.serialnumber )
                                || ( values.requesttype === 'rma' && values.problem_1 && values.product && values.serialnumber && values.terms_of_service && orderEntryState?.verificationCodeResponse)
                                || (values.requesttype === 'return' && (values.serialnumber || !product?.is_serialized) && values.product)
                                || ( (values.requesttype === 'receipt' || values.requesttype === 'installation') && hasProducts(values.products) && values.appointment_date )
                                || ( (values.requesttype === 'new') && hasProducts(values.products) )
                                || ( values.requesttype === 'accessory' && hasProducts(values.products) )
                                || ( values.requesttype === 'service' && hasProducts(values.products) )
                                && !!validAddress;
                    }
                }
            ]
        }
    ]
}
